import { createContext, useState } from "react";

const DisplaySpinnerContext = createContext();

const DisplaySpinnerContextProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  const setLoadingIndicator = (displayLoading) => {
    setIsLoading(displayLoading);
  };

  return <DisplaySpinnerContext.Provider value={{ setLoadingIndicator, isLoading }}>{children}</DisplaySpinnerContext.Provider>;
};

export { DisplaySpinnerContext, DisplaySpinnerContextProvider };
